interface NoBookedIconProps {
  width?: number;
  height?: number;
  className?: string;
  primaryColor: string;
  activeColor: string;
}

export default function NoBookedIcon({
  width = 30,
  height = 30,
  className,
  primaryColor,
  activeColor,
}: NoBookedIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M0 11.667V5.833H5.833V11.667H0Z" fill={activeColor} />
      <path d="M8.75 20.417V14.583H14.583V20.417H8.75Z" fill={activeColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 29.167V23.333H5.833V29.167H0ZM0 20.417V14.583H5.833V20.417H0ZM8.75 5.833H11.769C11.696 6.315 11.667 6.796 11.667 7.292C11.667 8.852 12.017 10.34 12.658 11.667H8.75V5.833Z"
        fill={activeColor}
      />
      <path
        d="M17.5 20.417V16.508C18.827 17.15 20.315 17.5 21.875 17.5C22.371 17.5 22.852 17.471 23.333 17.398V20.417H17.5Z"
        fill={activeColor}
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M17.5 23.333V29.167H23.333V23.333H17.5Z" fill={activeColor} />
      <path fillRule="evenodd" clipRule="evenodd" d="M8.75 29.167V23.333H14.583V29.167H8.75Z" fill={activeColor} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.875 0C25.9 0 29.167 3.267 29.167 7.292C29.167 11.317 25.9 14.583 21.875 14.583C17.85 14.583 14.583 11.317 14.583 7.292C14.583 3.267 17.85 0 21.875 0ZM20.882 12.27V8.313H16.873V6.276H20.882V2.319H22.902V6.276H26.911V8.313H22.902V12.27H20.882Z"
        fill={primaryColor}
      />
    </svg>
  );
}
